module.exports = __webpack_public_path__ + "static/img/sitting2.32e79a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sitting2.png
// module id = 285
// module chunks = 169